/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_cards_fees_tooltip = /** @type {(inputs: {}) => string} */ () => {
	return `Las comisiones se combinan de 3 capas: valores por defecto de la plataforma, configuración del origen y sobrecargas a nivel de tarjeta. Solo se muestran las sobrecargas de la tarjeta.`
};

const en_cards_fees_tooltip = /** @type {(inputs: {}) => string} */ () => {
	return `Fees are merged from 3 layers: platform defaults, origin settings, and card-level overrides. Only card-level overrides are shown here.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const cards_fees_tooltip = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cards_fees_tooltip(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("cards_fees_tooltip", locale)
	if (locale === "es") return es_cards_fees_tooltip(inputs)
	return en_cards_fees_tooltip(inputs)
};
export { cards_fees_tooltip as "cards.fees.tooltip" }